import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "slider-wr" }
const _hoisted_2 = { class: "house-slider-options-content" }
const _hoisted_3 = { class: "content-carousel-mobile-wr" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "house-selection-options" }
const _hoisted_6 = { class: "house-selection-options-name" }
const _hoisted_7 = { class: "house-selection-options-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.sliderOptions, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["content-carousel mobile", { 'selected-house-style': $props.selectedStyle?._id === option._id }]),
            key: option._id
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => ($setup.onSelectOptionStyle(option))
            }, [
              _createVNode($setup["CustomizeHouseSlider"], {
                sliderImages: option.imagesUrls,
                showArrows: true,
                zoomOnSelect: false
              }, null, 8, ["sliderImages"])
            ], 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(option.name), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(option.price >= 1 ? `+ ${$setup.formatPrice(option.price)}` : "Included"), 1)
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}